// BookButton.js
import React from "react";
import PropTypes from "prop-types";
import styles from './BookButton.module.css'; // Import the CSS module for styling

const BookButton = ({ onClick }) => {
  return (
    <button onClick={onClick} className={styles["book-button"]}>
      Jetzt buchen
    </button>
  );
};

// Add PropTypes for validation
BookButton.propTypes = {
  onClick: PropTypes.func.isRequired, // Requires a function to handle the click event
};

export default BookButton;
